import type { TradingProviderType, ProviderInfo } from './types';

// Trading provider information
export const TRADING_PROVIDERS: Record<TradingProviderType, ProviderInfo> = {
    papertrade: {
        id: 'papertrade',
        name: 'Paper Trading',
        description: 'Simulated trading for development and testing',
        requiresApiKey: false,
        requiresApiSecret: false,
        credentialFields: []
    },
    kite: {
        id: 'kite',
        name: 'Zerodha Kite',
        description: 'India\'s largest broker with API access',
        requiresApiKey: true,
        requiresApiSecret: true,
        credentialFields: [
            {
                key: 'redirectUrl',
                label: 'Redirect URL',
                valueGenerator: (userId?: string) => {
                    const baseUrl = import.meta.env.VITE_ENVIRONMENT === "development"
                        ? `https://zrifu7i0l6.execute-api.ap-south-2.amazonaws.com/default/provider_reconnect_route_dev`
                        : 'https://ocktra.com/api/provider/connect/zerodha';
                    return userId ? `${baseUrl}?userId=${userId}&provider_id=kite&provider_type=data_provider` : baseUrl;
                },
                type: 'text',
                placeholder: 'Generated based on your user ID',
                required: false,
                readonly: true,
                copyable: true,
                note: {
                    text: 'Copy this URL and add it to your Zerodha app redirect URLs.',
                    link: 'https://developers.kite.trade/docs/connect/v3/redirect/',
                    linkText: 'View setup guide'
                }
            },
            {
                key: 'apiKey',
                label: 'API Key',
                type: 'password',
                placeholder: 'Enter your API key...',
                required: true,
                note: 'Get your API key from Zerodha Kite Connect developer console.'
            },
            {
                key: 'apiSecret',
                label: 'API Secret',
                type: 'password',
                placeholder: 'Enter your API secret...',
                required: true,
                warning: {
                    text: 'Never share your API secret. Store it securely.',
                    link: 'https://developers.kite.trade/docs/connect/v3/security/',
                    linkText: 'Security best practices'
                }
            }
        ],
        website: 'https://developers.kite.trade/signup'
    }
};
